import { render, staticRenderFns } from "./DatasetIgnore.vue?vue&type=template&id=316565d9"
import script from "./DatasetIgnore.vue?vue&type=script&lang=js"
export * from "./DatasetIgnore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports